import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { Outlet, useLocation } from "react-router-dom";
import "../../Styles/DashboardStyles.css";
import FindMember from "../../components/FindMember/FindMember";
import FindMemberList from "../../components/FindMember/FindMemberList";
import FindMemberMenu from "../../components/FindMember/FindMemberMenu";
import ButtonWithIcon from "../../components/StyledComp/ButtonWithIcon";
import { screenConfig } from "../../config/screenConfig";
import {
  changeCreateMemberSection,
  changeCurrentMemberMenu,
  // screenChange,
} from "../../store/screenSlice";
import MemberServices from "../../services/MemberServices";
import CreateMemberPage from "./CreateMemberPage";
import MemberDetail from "../../components/MemberDetail/MemberDetail";
// import MDEditPersonalInfo from "../../components/FindMember/MDEdit/MDEditPersonalInfo";
// import MDEditPrimaryAddress from "../../components/FindMember/MDEdit/MDEditPrimaryAddress";
// import MDEditPublishedAddress from "../../components/FindMember/MDEdit/MDEditPublishedAddress";
// import MDEditSections from "../../components/FindMember/MDEdit/MDEditSections";
import { useAppSelector, useAppDispatch } from "../../store/hooks";
import {
  assignMemberPersonal,
  assignMemberPrimaryAddress,
  assignMemberPublishedAddress,
} from "../../store/editMemberapiSlice";
import { IAddressType } from "../../store/memberInterfaceStruct";
// import MDEditMemberTags from "../../components/FindMember/MDEdit/MDEditMemberTags";
import FMSavedSearchList from "../../components/FindMember/FMSavedSearchList";
// import MDEditFirmDetail from "../../components/FindMember/MDEdit/MDEditFirmDetail";
// import MDEditOtherStateBar from "../../components/FindMember/MDEdit/MDEditOtherStateBar";
import FindMemberListSavedQuery from "../../components/FindMember/FindMemberListSavedQuery";
import SendEmail from "../../pages/members/SendEmailPage";
import PrintMemberLabel from "./PrintMemberLabel";
import CreateOrder from "../../components/Order/CreateOrder";
import ViewEvent from "../../components/Events/ViewEvent";
import CreateEvent from "../../components/Events/CreateEvent";
import AlertWithModal from "../../components/utilityComponents/AlertWithModal";

const MemberHomePage: React.FC = () => {
  const currentMember = useAppSelector((state) => state.currentMember);
  const currentMemberData = currentMember;

  let memberPersonal = {
    Id: currentMemberData?.Id,
    BarId: currentMemberData?.BarId,
    MemberTypeId: currentMemberData?.MemberTypeId,
    MemberCodeId: currentMemberData?.MemberCodeId,
    Title: currentMemberData?.Title,
    Esquire: currentMemberData?.Esquire,
    FirstName: currentMemberData?.FirstName,
    LastName: currentMemberData?.LastName,
    Gender: currentMemberData?.Gender,
    DateOfBirth: currentMemberData?.DateOfBirth?.toString().split("T")[0],
    AdmitDate: currentMemberData?.AdmitDate?.toString().split("T")[0],
    IsValidSupremeCourtId: currentMemberData?.IsValidSupremeCourtId,
    IsMediator: currentMemberData?.IsMediator,
    IsArbitrator: currentMemberData?.IsArbitrator,
    MediatorCertificationEndsOn:
      currentMemberData?.MediatorCertificationEndsOn?.toString().split("T")[0],
    Comments:currentMember?.Comments,
  };
  let address = currentMember.Address;
  const dispatch = useDispatch();
  console.log("editMemberapiSlice in member home page:", memberPersonal);
  dispatch(assignMemberPersonal(memberPersonal));

  let primaryAddreess: IAddressType;
  // if (typeof address != "undefined") {
  //   if (address!.length > 0) {
  //     primaryAddreess = address![0];
  //     dispatch(assignMemberPrimaryAddress(primaryAddreess));
  //   }
  //   if (address!.length > 1) {
  //     let publishedAddreess = address![1];
  //     dispatch(assignMemberPublishedAddress(publishedAddreess));
  //   }
  // }

  dispatch(assignMemberPrimaryAddress(currentMember.PrimaryAddress!));
  dispatch(assignMemberPublishedAddress(currentMember.PublishedAddress!));

  // dispatch(screenChange("Members"));
  const currentMemberMenu = useSelector(
    (state: RootState) => state.screen.currentMenu
  );

  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");

  useEffect(() => {
    dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
    dispatch(changeCreateMemberSection(screenConfig.personal));
    // console.log("currentMemberMenu:", currentMemberMenu);
  }, []);

  interface IConfiguration {
    [key: string]: any;
  }

  const [configurationList, setConfigurationLists] = useState<IConfiguration>(
    {}
  );

  useEffect(() => {
    const getConfigurationLists = async () => {
      console.log("getAdminList called");
      const response = await MemberServices.getConfigurationList();
      console.log("response...", response.data.data);
      if (response.data.data != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Database Error");
          setAlertBody(response.data.errors[0].sqlMessage);
          return;
        }
        console.log("Success");
        // console.log("response1...", response.data.data);
        setConfigurationLists(response.data.data);
      } else {
      }
    };

    getConfigurationLists();
  }, []);

  const renderMenuPage = () => {
    switch (currentMemberMenu) {
      case screenConfig.memberListScreen:
        return <FindMemberList />;
        break;
      // case screenConfig.memberFindScreen:
      //   return <FindMember />;
      //   break;
      // case screenConfig.memberCreateScreen:
      //   return <CreateMemberPage />;
      //   break;
      // case screenConfig.memberDetailScreen:
      //   return <MemberDetail />;
      //   break;
      // case screenConfig.savedSearchList:
      //   return <FMSavedSearchList />;
      //   break;
      // case screenConfig.memberEditPersonalInfoScreen:
      //   // return (
      //   //   <MDEditPersonalInfo
      //   //     MemberCode={configurationList.MemberCode}
      //   //     MemberType={configurationList.MemberTypes}
      //   //     CurrentMember={currentMember}
      //   //   />
      //   // );
      //   break;
      // case screenConfig.memberEditPrimaryAddressScreen:
      //   // return (
      //   //   <MDEditPrimaryAddress
      //   //     MemberCode={configurationList.MemberCode}
      //   //     MemberType={configurationList.MemberTypes}
      //   //     CurrentMember={currentMember}
      //   //   />
      //   // );
      //   break;
      // case screenConfig.memberEditPublishedAddressScreen:
      //   // return (
      //   // <MDEditPublishedAddress
      //   //   MemberCode={configurationList.MemberCode}
      //   //   MemberType={configurationList.MemberTypes}
      //   //   CurrentMember={currentMember}
      //   // />
      //   // );
      //   break;
      // case screenConfig.memberEditSessionInfoScreen:
      //   // return <MDEditSections CurrentMember={currentMember} />;
      //   break;
      // case screenConfig.memberEditMemberTagScreen:
      //   // return <MDEditMemberTags CurrentMember={currentMember} />;
      //   break;
      // case screenConfig.memberEditFirmDetailScreen:
      //   // return <MDEditFirmDetail CurrentMember={currentMember} />;
      //   break;
      // case screenConfig.memberEditOtherStateBarScreen:
      //   // return <MDEditOtherStateBar CurrentMember={currentMember} />;
      //   break;
      case screenConfig.findMemberListSavedQuery:
        return <FindMemberListSavedQuery />;
        break;
      case screenConfig.sendEmailScreen:
        return <SendEmail />;
        break;
      case screenConfig.printLabelScreen:
        return <PrintMemberLabel />;
        break;
      // case screenConfig.createOrder:
      //   return <CreateOrder />;
      //   break;
      // // case screenConfig.viewEvent:
      //   return <ViewEvent />;
      //   break;
      // case screenConfig.createEvent:
      //   return <CreateEvent />;
      //   break;

      default:
        break;
    }

    // if (currentMemeberMenu == screenConfig.memberListScreen) {
    //   return <FindMemberList />;
    // } else if (currentMemeberMenu == screenConfig.memberFindScreen) {
    //   return <FindMember />;
    // } else if (currentMemeberMenu == screenConfig.memberCreateScreen) {
    //   return <CreateMemberPage />;
    // }
  };

  return (
    <div
      className="dashboard-wrapper"
      style={{ paddingBottom: "1rem", paddingTop: "0.5rem", height: "100%" }}
    >
      {/* <MemberDetail /> */}
      {renderMenuPage()}
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default MemberHomePage;
